import React from 'react';

const News = ({ postCategories }) => {
    return null;
}

export default News;
